import { type } from 'arktype'

// NOTE!
// this reads from the .env file NOT at the root of the project, but at the root of the apps/web folder

console.log('inside env-web')
const envWebSchema = type({
    // NEXT_PUBLIC_PRODUCTION_URL: "string",
    VITE_PRODUCTION_URL: 'string',
    VITE_BACKEND_URL: 'string',
    MODE: 'string',
    VITE_PUBLIC_MAPS_API_KEY: 'string',
    VITE_PUBLIC_POSTHOG_KEY: 'string',
    VITE_PUBLIC_POSTHOG_HOST: 'string',
}).onUndeclaredKey('delete')

type EnvWebSchema = typeof envWebSchema.infer

// console.log({ env: import.meta.env })
const envWebRaw = envWebSchema(import.meta.env)

if (envWebRaw instanceof type.errors) {
    if (process.env.NODE_ENV !== 'CI') {
        console.error('❌ Environment Error:', envWebRaw.summary)
        throw new Error(`❌ Environment Error, ${envWebRaw.summary}`)
    } else {
        console.log('inside CI Environment, skipping validation')
    }

    // TODO: implement in check-env.ts, then call that from check-env script for turbo
    // // Only throw during build/CLI, not in production runtime
    // const isNode =
    //   typeof process !== "undefined" && process.release?.name === "node";
    // const isBuildPhase = process.env.NEXT_PHASE === "phase-production-build";
    // const isTTY = typeof process.stdout !== "undefined" && process.stdout.isTTY;
    // if (isNode && (isBuildPhase || isTTY)) {
    //   console.error("❌ Environment Error:", envWebRaw.summary);
    //   // console.error({ envWebRaw });
    //   // throw new Error("Environment Error");
    //   process.exit(1);
    // }
}
// console.log({ envWebRaw })

export const envWeb = envWebRaw as EnvWebSchema
